import { CAP_IQ_DEFAULT_UNIT, DEFAULT_COMPANY_SUMMARY_CURRENCY, MONTHS } from './FundingRoundsCard.constants';

export function formatAmount(value: number | null | undefined, currency?: string | null): string {
  if (value == null) {
    return '—';
  }
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  let suffix: string;
  if (abs >= 1e9) {
    suffix = `${(abs / 1e9).toFixed(1)}B`;
  } else if (abs >= 1e6) {
    suffix = `${(abs / 1e6).toFixed(0)}M`;
  } else {
    suffix = `${(abs / 1e3).toFixed(0)}K`;
  }
  const symbol = currency === DEFAULT_COMPANY_SUMMARY_CURRENCY || !currency ? '$' : `${currency} `;
  return `${sign}${symbol}${suffix}`;
}
  
/** Cap IQ returns values in USD millions ($ mm) as strings. */
export function formatCapIQAmount(raw: string | null | undefined): string {
  if (!raw) {
    return '—';
  }
  const num = Number.parseFloat(raw);
  if (Number.isNaN(num)) {
    return raw;
  }
  return formatAmount(num * CAP_IQ_DEFAULT_UNIT, DEFAULT_COMPANY_SUMMARY_CURRENCY);
}
  
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) {
    return '—';
  }
  
  // YYYY-MM-DD (Sacra)
  if (dateStr.includes('-')) {
    const [year, month, day] = dateStr.split('-');
    return `${MONTHS[Number(month) - 1]} ${day}, ${year}`;
  }
  
  // MM/DD/YYYY (Cap IQ)
  if (dateStr.includes('/')) {
    const [month, day, year] = dateStr.split('/');
    return `${MONTHS[Number(month) - 1]} ${day}, ${year}`;
  }
  
  return dateStr;
}